<template>
    <v-sheet
        theme="dark"
        color="rgba(0,0,0,0.87)"
        width="300"
        class="pa-4 d-flex flex-column align-start justify-center cookies"
    >
        <span class="text-h6"> {{ $t('cookies') }} </span>
        <span class="text-caption my-2"> {{ $t('cookies_alert') }} </span>
        <v-btn color="success caption" elevation="0" @click="closeDialog">
            <span> {{ $t('understood') }} </span>
        </v-btn>
    </v-sheet>
</template>

<script lang="ts">
    import {Component, Emit, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class CookiesAlert extends Vue {
        @VModel() showDialog

        @Emit()
        closeDialog() {}
    }

    export default CookiesAlert
</script>

<style lang="scss" scoped>
    .cookies {
        position: fixed;
        right: 12px;
        bottom: 12px;
        z-index: 1200;
    }
</style>
